import { market } from '../constants';
import { APP_SETTINGS } from '../settings/AppSettings';

const { CHILE, PERU } = APP_SETTINGS.COUNTRIES;

export const stateParser = (state) => {
  let finalState = {};
  Object.keys(state).forEach((key) => {
    // RESOLVE: must be '' or null?, all this needs a unit test!.
    finalState[key] = key !== 'logonId' ? state?.[key].value : '';
    return finalState;
  });
  finalState['gender'] = ' ';
  finalState['middleName'] = ' ';
  return finalState;
};

export const getLogonIdToGetOrders = (logonId) => {
  switch (market) {
    case PERU.SHORT_NAME:
      return logonId;
    case CHILE.SHORT_NAME:
      return logonId.slice(0, -1);
    default:
      return '';
  }
};
